import { render, staticRenderFns } from "./modal-na-link.vue?vue&type=template&id=499fc3d8&scoped=true&"
import script from "./modal-na-link.vue?vue&type=script&lang=js&"
export * from "./modal-na-link.vue?vue&type=script&lang=js&"
import style0 from "./modal-na-link.vue?vue&type=style&index=0&id=499fc3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499fc3d8",
  null
  
)

export default component.exports